import { render, staticRenderFns } from "./Teams.vue?vue&type=template&id=09fffd23&scoped=true&"
import script from "./Teams.vue?vue&type=script&lang=js&"
export * from "./Teams.vue?vue&type=script&lang=js&"
import style0 from "./Teams.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Teams.vue?vue&type=style&index=1&id=09fffd23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fffd23",
  null
  
)

export default component.exports